// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__1kMCN","content":"AdminPage_content__oWZ-N"};